import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "member-info-area" }
const _hoisted_2 = { class: "org-name" }
const _hoisted_3 = { class: "biz-gubun" }

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import MemberNavi from './MemberNavi.vue';
import { MEMBER_NAVIGATION_ITEMS, type NavItem } from '@/config/navigation';


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberLayout',
  setup(__props) {

const store = useStore();
const router = useRouter();

const drawer = ref(false);

const currentUser = computed(() => store.getters.currentUser);
const bizGubunName = computed(() => store.getters.bizGubunName);
/** 메뉴 minRole은 실제 운영자 권한 기준 (대리 로그인 시에도 admin 전용 메뉴 유지) */
const roleLevel = computed(() =>
  Number(store.getters.actualRoleLevel ?? store.getters.roleLevel ?? 0)
);

const filterMenuByRole = (items: NavItem[]): NavItem[] => {
  return items
    .filter((item) => {
      const minRole = item.minRole ?? 0;
      return roleLevel.value >= minRole;
    })
    .map((item) => {
      if (!item.children) return item;
      const children = filterMenuByRole(item.children);
      if (children.length === 0) return { ...item, children: [] };
      return { ...item, children };
    })
    .filter((item) => !item.children || item.children.length > 0 || !!item.to);
};

const filteredMenuItems = computed(() => filterMenuByRole(MEMBER_NAVIGATION_ITEMS));

const goToMyInfo = () => {
  router.push('/m/myinfo');
};

const handleLogout = () => {
  store.dispatch('logout');
  window.location.href = '/login';
};

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "member-layout" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "white",
        elevation: "1",
        height: "56",
        class: "member-app-bar"
      }, {
        default: _withCtx(() => [
          _createVNode(MemberNavi, {
            modelValue: drawer.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
            "menu-items": filteredMenuItems.value,
            "current-user-name": currentUser.value?.name || '',
            "biz-gubun-name": bizGubunName.value
          }, null, 8, ["modelValue", "menu-items", "current-user-name", "biz-gubun-name"]),
          _createVNode(_component_v_toolbar_title, { class: "app-title" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "title-text" }, "CAION", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(currentUser.value?.name), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(bizGubunName.value), 1)
          ]),
          _createVNode(_component_v_menu, null, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, { class: "mr-2" }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-account-circle", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, { density: "compact" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, { onClick: goToMyInfo }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-information-outline", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("내 정보", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, { onClick: handleLogout }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-logout", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("로그아웃", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, { class: "member-main" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})